import { Component, OnInit } from '@angular/core';
import get from 'lodash-es/get';

import { ModalChildComponent } from '@finder/shared/components/modal/modal-child-component.interface';
import { ModalComponent } from '@finder/shared/components/modal/modal.component';

@Component({
    selector: 'finder-discounts-modal',
    templateUrl: './discounts-modal.component.html',
    styleUrls: ['./discounts-modal.component.scss']
})
export class DiscountsModalComponent implements ModalChildComponent, OnInit {

    parentComponent: ModalComponent;
    diningPlan: any;
    disneyVisa: any;
    expanded: boolean;
    annualPass: any;
    dvc: any;
    data: any;
    fragments = [];

    ngOnInit() {
        this.diningPlan = get(this.data.sections, 'diningPlan');
        this.disneyVisa = get(this.data.sections, 'disneyVisa');
        this.annualPass = get(this.data.sections, 'annualPass');
        this.dvc = get(this.data.sections, 'dvc');

        if (this.annualPass) {
            this.setupAnnualPass();
        }
        // If we have one section in the modal, it should be expanded as a default.
        this.expanded = Object.keys(this.data.sections).length === 1;
    }

    updateFragments(fragments) {
        this.fragments = fragments;
    }

    setupAnnualPass() {
        const labels = this.annualPass.labels;

        /**
         *  If we have discounts set the validDays in the breadcrumb template (dlr)
         *  If not, replace the discount value in the section description (wdw)
         */
        if (this.annualPass.discounts) {
            labels.breadcrumbTemplate = labels.breadcrumbTemplate.replace('{validDays}', this.annualPass.validDays);
        } else {
            labels.description = labels.description.replace('{percentage}', this.annualPass.percentage);
            labels.breadcrumbTemplate = `${this.annualPass.disclaimer}  ${labels.breadcrumbTemplate}`;
        }
    }
}
